import { createFileRoute } from "@tanstack/react-router";
import WeeklyMilestones from "../components/milestones/weekly-milestones";

export const Route = createFileRoute("/milestones")({
  component: RouteComponent,
});

function RouteComponent() {
  return <WeeklyMilestones />;
}
